import Com from '../detail';
import css from './index.module.scss';
import CrowdFundingPC from '@/components/CrowdFunding';
import { useGlobal } from '@/utils/useGlobal';
import { bundleData } from '@/data/crowdfunding/glacier';
import { ACTIVITY_MAP } from '@/constants/glacier';

export default function CrowdFunding({ productDetail, resProductCatagory, nowSysTime, supportData, crowdfundingTimeline }: any) {
    const { useRouter, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('glacier');
    const bundlesData = bundleData[locale] || bundleData.us;
    const activityId = ACTIVITY_MAP[locale] || ACTIVITY_MAP.us;
    const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
    const imgsArr = [
        `/media/glacier/crowdfunding/pc/banner1${['jp'].includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? '_eu' : ''}.jpg`,
        `/media/glacier/crowdfunding/pc/banner2${['jp'].includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? '_eu' : ''}.jpg`,
        `/media/glacier/crowdfunding/pc/banner3${['jp', 'uk'].includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? '_eu' : ''}.jpg`,
        `/media/glacier/crowdfunding/pc/banner4${['jp'].includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? '_eu' : ''}.jpg`,
    ];
    const bannerData = {
        // 1.EFPic 2.Image 建议1
        swiperImgs: EU_SITES.includes(locale)
            ? imgsArr
            : [...imgsArr, `/media/glacier/crowdfunding/pc/banner5${['jp'].includes(locale) ? `_${locale}` : ''}.jpg`],
        webpUrl: '',
        subTitle: '',
        title: t('crowdfunding.header.title'),
        // promotion: t('crowdfunding.header.promotion'),
        desc: t.rich('crowdfunding.header.desc', {
            dot: (text: string) => <span className="dot">{text}</span>,
        }),
        showTC: ['us', 'ca', 'jp'].includes(locale), // 是否显示问号 T&C内容弹窗
        productKey: 'glacier',
        // buyNowText: ['de', 'fr'].includes(locale) ? t('crowdfunding.header.btn') : undefined,
    };

    const shopifyBtnProps = {
        /// domain & token
        options: (() => {
            const map: any = {};
            return map[locale] || null;
        })(),
        // 购物车
        cartText: {
            title: t('crowdfunding.shopify_btn.title'),
            total: t('crowdfunding.shopify_btn.total'),
            empty: t('crowdfunding.shopify_btn.empty'),
            notice: t('crowdfunding.shopify_btn.notice'),
            button: t('crowdfunding.shopify_btn.button'),
        },
    };
    return (
        <div className={`glacier-crowdfunding ${css.glacierCrowdfunding}`}>
            <CrowdFundingPC
                productDetail={productDetail}
                resProductCatagory={resProductCatagory}
                nowSysTime={nowSysTime}
                bundlesData={bundlesData}
                supportData={supportData}
                bannerData={bannerData}
                crowdfundingTimeline={crowdfundingTimeline}
                shopifyBtnProps={shopifyBtnProps}
                activityId={activityId}
                isPreOrder={['ca'].includes(locale)}
                getShopifyPrice={['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale)}
                hideBundles={['za'].includes(locale)}
                Com={Com}
            />
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
